import SpriteSymbol from "../../../../../../../ldplatform/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../ldplatform/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-add",
  "use": "icon-add-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-add\"><path d=\"M512 832a32 32 0 0 0 32-32v-256h256a32 32 0 0 0 0-64h-256V224a32 32 0 0 0-64 0v256H224a32 32 0 0 0 0 64h256v256a32 32 0 0 0 32 32\" p-id=\"3874\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol